import React, { useState, useEffect, useRef } from "react";
import "./ChatDisplay.scss";
import ChatResponse from "./ChatResponse";

const ChatDisplay = ({
  setIsLoading,
  isLoading,
  responceData,
  query,
  printPDF,
  loadingIndex,
  setResponceData,
  isHistory,
  page,
  handleSendClickNew,
  // displayedLogs
}) => {

  
  return (
    <div className="response-cont">
      {responceData.map((message, index) => (
        <ChatResponse
          key={index}
          message={message}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          index={index}
          printPDF={printPDF}
          loadingIndex={loadingIndex}
          setResponceData={setResponceData}
          isHistory={isHistory}
          page={page}
          responceData={responceData}
          handleSendClickNew={handleSendClickNew}
          displayedLogs={message?.logs && message?.logs.length > 0 ? message?.logs : []}
          query={query}
        />
      ))}
    </div>
  );
};

export default ChatDisplay;
